import { render, staticRenderFns } from "./DividerIcon.vue?vue&type=template&id=059d06a6&"
import script from "./DividerIcon.vue?vue&type=script&lang=js&"
export * from "./DividerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports